import { IrisNotificationPriorityEnum } from '../models/IrisNotificationPriorityEnum';
import { StrakitToastTypeEnum } from '@ngx-strakit/cdk/controls/toast';

export interface ToastMapI {
  type: StrakitToastTypeEnum;
  message?: string;
}

export function mapToToast(notification: IrisNotificationI) : Pick<ToastMapI, 'type' | 'message'> {
  let toastType: StrakitToastTypeEnum;

  switch (notification?.notificationPriority?.id) {
    case IrisNotificationPriorityEnum.Minor:
      toastType = StrakitToastTypeEnum.Info;
      break;
    case IrisNotificationPriorityEnum.Normal:
      toastType = StrakitToastTypeEnum.Success;
      break;
    case IrisNotificationPriorityEnum.Major:
      toastType = StrakitToastTypeEnum.Warning;
      break;
    case IrisNotificationPriorityEnum.Blocker:
    case IrisNotificationPriorityEnum.Critical:
      toastType = StrakitToastTypeEnum.Error;
      break;
    default:
      toastType = StrakitToastTypeEnum.Log;
  }

  return {
    type: toastType,
    message: notification?.message,
  };
}
